import Vue from 'vue'
import './../styles/loading.scss'
import ImgList from './../config/imgList'


const findEle = (parent, type) => {
  return parent.tagName.toLowerCase() === type ? parent : parent.querySelector(type)
}

let directives = {
  hasPermission: {
    bind(el, binding, vnode) {
      let meta = vnode.context.$route.meta
      let permissions = []
      if (meta && meta.permissions) {
        permissions = meta.permissions
      }
      let value = binding.value
      let flag = permissions.includes(value)
      if (!flag) {
        //加这行代码的原因是： 初始化mount时候 el是没有 parent的,
        // 必须用一个微任务让节点挂载完成才行
        //不用宏任务原因在于减少渲染操作
        Promise.resolve().then(() => {
          if (!el.parentNode) {
            el.style.display = 'none'
          } else {
            el.parentNode.removeChild(el)
          }
        })
      }
    }
  },
  cusBack: {
    bind: (el, binding) => {
      el.style.backgroundColor = binding.backgroundColor
    }
  },
  cLoading: {
    bind: (el, binding) => {
      const tempDiv = document.createElement('div')
      tempDiv.className = 'custom-loading'
      const round = document.createElement('div')
      let cusClassName
        ;['large', 'mini', 'small'].forEach((item) => {
          if (binding.modifiers[item]) {
            cusClassName = item
          }
        })
      round.className = 'custom-loading-round ' + (cusClassName || '')
      tempDiv.appendChild(round)
      el.loadingElement = tempDiv
      const curStyle = window.getComputedStyle(el)
      const position = curStyle.position
      if (!position) {
        el.style.position = 'relative'
      }
      if (binding.value) {
        el.appendChild(tempDiv)
      }
    },
    update: (el, binding) => {
      if (binding.value) {
        if (el.loadingElement.parentNode === null) {
          el.appendChild(el.loadingElement)
        }
      } else {
        if (el === el.loadingElement.parentNode) {
          el.removeChild(el.loadingElement)
        }
      }
    },
    unbind: (el) => {
      if (el.loadingElement.parentNode === el) {
        el.removeChild(el.loadingElement)
      }
      el.loadingElement = null
    }
  },
  asset: {
    bind(el, binding) {
      let imgValue = binding.value || binding.expression
      if (ImgList[imgValue]) {
        el.src = ImgList[imgValue]
      }
    }
  },
  emoji: {
    bind(el, binding, vnode, oldVnode) {
      const regex = /(\ud83c[\udc00-\udfff])|(\ud83d[\udc00-\udfff])|(\ud83e[\udc00-\udfff])|[\u2100-\u32ff]|[\u0030-\u007f][\u20d0-\u20ff]|[\u0080-\u00ff]/g;
      const obj = findEle(el, 'input') || findEle(el, 'textarea');
      const zclearNoNum = function (e) {
        if (e.target.composing) return;
        const match = regex.exec(obj.value);
        if (match) {
          /* for (let i=0;i<match.length;i++) {
            obj.value = obj.value.replace(match[i],"");
          }*/
          obj.value = obj.value.replace(regex, '');
          zclearNoNum(e);
        }
        // 触发v-model的更新
        obj.dispatchEvent(new Event('input'));
      }
      const zblur = function (e) {
        zclearNoNum(e);
        setTimeout(() => {
          const match = regex.exec(obj.value);
          if (match) {
            obj.value = obj.value.replace(regex, '');
            zclearNoNum(e);
          }
          // 触发v-model的更新
          obj.dispatchEvent(new Event('change'));
        }, 10)
      }
      obj.onkeyup = zclearNoNum;
      obj.onblur = zblur;


      function onCompositionStart(e) {
        e.target.composing = true
      }
      function onCompositionEnd(e) {
        // console.log('按回车将字输入', e.target.value)
        e.target.composing = false
        obj.dispatchEvent(new Event('change'));
        setTimeout(() => {
          if (obj.value) {
            obj.value = obj.value.replace(regex, '');
            zclearNoNum(e);
          }
          // 触发v-model的更新
          obj.dispatchEvent(new Event('change'));
        }, 10)
      }
      obj.addEventListener('compositionstart', onCompositionStart)
      obj.addEventListener('compositionend', onCompositionEnd)
    },
    update(el, binding, vnode, oldVnode) { }

  }
}

Object.keys(directives).forEach((key) => {
  Vue.directive(key, directives[key])
})



// WEBPACK FOOTER //
// ./src/script/directive.js